import React from "react";
import { connect } from "react-redux";
import { loadSubMenu } from "../actions";

import MainDiagnosticoPlanMovilidad from "./main";
import EncuestaCentroPlanMovilidad from "./EncuestaCentro/view";
import EncuestaTrabajadorPlanMovilidad from "./EncuestaTrabajador/view";
import FinalizarDiagnosticoPlanMovilidad from "./finalizar";

class DiagnosticoPlanMovilidad extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadSubMenu();
  }

loadSubMenu = () => {
  const tabs = [
    { text: "Main", contentId: 0 },
    { text: "Encuesta Centro Trabajo", contentId: 1 },
    { text: "Encuesta Trabajador", contentId: 2 },
    { text: "Finalizar", contentId: 3 },

  ];
  this.props.dispatch(loadSubMenu(tabs, tabs.length ? tabs[0].contentId : null));
}

renderBody = () => {
  switch (this.props.subMenuPosition) {
    case 0: {
      return (<MainDiagnosticoPlanMovilidad />);
    }
    case 1: {
      return (<EncuestaCentroPlanMovilidad />);
    }
    case 2: {
      return (<EncuestaTrabajadorPlanMovilidad />);
    }
    case 3: {
      return (<FinalizarDiagnosticoPlanMovilidad />);
    }
    default:
      return <div />;
  }
}

render() {
  return (
    <React.Fragment>
      {this.renderBody()}
    </React.Fragment>
  );
}
}

const mapStateToProps = (state) => ({
  planMovilidad: state.planMovilidad,
  subMenuPosition: state.planMovilidad.subMenuPosition,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DiagnosticoPlanMovilidad);
